module.exports = __webpack_public_path__ + "assets/img/entico2.f99688f8.jpg";